module.exports = "/assets/13bfe856df7dad4e5b0df975fb49691d.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/4Y.png
// module id = 2180
// module chunks = 0